<template>
    <v-container >
        <v-row class="contentRow">
            <v-col>
                <h1 class="mb-2 darkColor--text">
                    Internal Comments for All Transactions
                </h1>
            </v-col>
        </v-row>
        <v-row class="contentRow" align="center">
            <v-col>
                <v-card background-color="transparent" elevation="0" outlined>
                    <v-card-title class="text-center justify-left py-6">
                        <h3 class="darkColor--text">Internal Comments</h3>
                    </v-card-title>
                    <v-data-table
                            :loading="commentOptions.loading"
                            theme--
                            light
                            :headers="headers"
                            :items="commentOptions.data"
                            :items-per-page="commentOptions.limit"
                            :server-items-length="commentOptions.total"
                            :options.sync="commentOptions.options"
                            class="light table mx-4 assessed-table"
                            :footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                    >
                        <template v-slot:item.type="{ item }"  >
                            <v-chip
                                    v-if="item.type==='note'"
                                    color="success"
                                    label
                                    text-color="white"
                                    small
                            >
                                <v-icon left small>
                                    fas fa-sticky-note
                                </v-icon>
                                Note
                            </v-chip>
                            <v-chip
                                    v-if="item.type==='issue'"
                                    color="error"
                                    label
                                    text-color="white"
                                    small
                            >
                                <v-icon left small>
                                    fas fa-exclamation
                                </v-icon>
                                Issue
                            </v-chip>
                        </template>
                        <template v-slot:item.message="{ item }">
                            <router-link :to="`/trace/transactions/${item.transactionID}/comments/${item.id}`" style="text-decoration: inherit">
                                {{item.message}}
                            </router-link>
                        </template>
                        <template v-slot:item.currentStatus="{ item }"  >
                            <v-chip
                                    v-if="item.currentStatus===0"
                                    label
                                    text-color="black"
                                    small
                            >
                                <v-icon left small>
                                    fas fa-ellipsis-h
                                </v-icon>
                                Open
                            </v-chip>
                            <v-chip
                                    v-if="item.currentStatus===1"
                                    color="primary"
                                    label
                                    text-color="white"
                                    small
                            >
                                <v-icon left small>
                                    fas fa-check-circle
                                </v-icon>
                                Closed
                            </v-chip>
                        </template>
                        <template v-slot:item.transactionID="{ item }">
                            <router-link :to="`/trace/transactions/${item.transactionID}`" style="text-decoration: inherit">{{item.transactionID}}</router-link>
                        </template>
                        <template v-slot:item.transactionRole="{ item }">
                         <span v-if="item.transactionRole===1">
                             Sender
                         </span>
                            <span v-if="item.transactionRole===2">
                             Recipient
                         </span>
                            <span v-if="item.transactionRole!==2 && item.transactionRole!==1  ">
                             Unknown
                         </span>
                        </template>
                    </v-data-table>
                    <br />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import CommentsAPI from "../../api/trace/comments"
import LoadingState from "../../consts/LoadingState"
export default {
	name: "CommentsListView",
	data() {
		return {
			commentOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				loading:true,
				options: {},
			},
			headers:[
				{
					text: "Type",
					align: "start",
					sortable: false,
					value: "type",
					class: "secondary--text"
				},
				{
					text: "Message",
					value: "message",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Opened By",
					value: "createdBy",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Status",
					value: "currentStatus",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Transaction ID",
					value: "transactionID",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Transaction Role",
					value: "transactionRole",
					sortable: false,
					class: "secondary--text"
				},
			]
		}
	},
	mounted() {
		this.getCommentsList()
	},
	watch:{
		"commentOptions.options": {
			handler () {
				//if user select all
				if (this.commentOptions.options.itemsPerPage===-1){
					this.commentOptions.options.itemsPerPage=this.commentOptions.total
				}
				this.commentOptions.offset=(this.commentOptions.options?.page-1) * this.commentOptions.options?.itemsPerPage
				this.commentOptions.limit=this.commentOptions.options?.itemsPerPage
				this.getCommentsList()
			},
			deep: true,
		},
	},
	methods: {
		getCommentsList(){
			this.commentOptions.loading=true
			CommentsAPI.getAllComments(this.commentOptions.limit,this.commentOptions.offset)
				.then(data => {
					this.commentOptions.total=data?.metadata?.pagination?.totalRecords
					this.commentOptions.data=data?.data
					this.commentOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.commentOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
	},
}
</script>